import { render, staticRenderFns } from "./RummyRetailerCommissionDashboard.vue?vue&type=template&id=7bb60671"
import script from "./RummyRetailerCommissionDashboard.vue?vue&type=script&lang=js"
export * from "./RummyRetailerCommissionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports